import React from 'react';
import ATMPageHeader from 'src/components/UI/atoms/ATMPageHeader/ATMPageHeader';
import ATMPagination from 'src/components/UI/atoms/ATMPagination/ATMPagination';
import ATMTable, {
  columnTypes,
} from 'src/components/UI/atoms/ATMTable/ATMTable';
import SideNavLayout from 'src/components/layouts/SideNavLayout/SideNavLayout';
import {useNavigate} from 'react-router-dom' 

type Props = {
  columns: columnTypes[];
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const MeetingListing = ({
  columns,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
    const navigate = useNavigate()
  return (
    <SideNavLayout>
      <div className='flex flex-col h-full'>
        {/* Page Header */}
        <div className='p-4'>
          <ATMPageHeader
            pageTitle='Meetings'
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            hideAddButton
          />
        </div>

        {/* Table */}
        <div className='flex-1 overflow-auto flex flex-col'>
            <ATMTable
              columns={columns}
              rows={rows}
              rowExtraClasses={() => 'min-h-[40px]'}
              isLoading={isTableLoading}
              onRowClick={(row) => row?.status !== "PENDING" && navigate(`/meeting/${row?._id}/mom`)}
            />
        </div>

        <div className='p-4 py-2'>
            <ATMPagination
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={setPage}
              onRowsPerPageChange={setRowsPerPage}
              rowCount={totalItems}
              rows={rows}
            />
          </div>
      </div>
    </SideNavLayout>
  );
};

export default MeetingListing;